/**
 * useFeatures Hook
 *
 * One-time fetch of product features from Firestore.
 * Features are admin-seeded and immutable at runtime — no live listener needed.
 * The SDK's persistentLocalCache provides offline support.
 */

import { getAllFeatures } from "../services/planService";
import type { Feature } from "../types/plan";
import { useOneShotFetch } from "./useOneShotFetch";

const sortByOrder = (a: Feature, b: Feature): number => a.order - b.order;

/**
 * Hook to fetch product features once
 *
 * @returns Features sorted by order field
 */
export function useFeatures() {
  const {
    data: features,
    loading,
    error,
  } = useOneShotFetch(getAllFeatures, {
    sort: sortByOrder,
  });

  return {
    features,
    loading,
    error,
    listening: false,
  };
}
